// services/learningApiClient.js
import ApiClient from './apiClient';

class LearningApiClient {
  constructor() {
    this.apiClient = ApiClient;
  }

  // Course management
  async getCourses(category = null) {
    const endpoint = category ? `/api/courses?category=${category}` : '/api/courses';
    return this.apiClient.request(endpoint);
  }

  async getCourseDetails(courseId) {
    return this.apiClient.request(`/api/courses/${courseId}`);
  }

  async enrollInCourse(courseId) {
    return this.apiClient.request(`/api/courses/${courseId}/enroll`, {
      method: 'POST',
    });
  }

  async getUserCourses() {
    return this.apiClient.request('/api/users/courses');
  }

  // Books management
  async getBooks(category = null) {
    const endpoint = category ? `/api/books?category=${category}` : '/api/books';
    return this.apiClient.request(endpoint);
  }

  async getBookDetails(bookId) {
    return this.apiClient.request(`/api/books/${bookId}`);
  }

  // Internships management
  async getInternships() {
    return this.apiClient.request('/api/internships');
  }

  async applyForInternship(internshipId) {
    return this.apiClient.request(`/api/internships/${internshipId}/apply`, {
      method: 'POST',
    });
  }

  // Certificates
  async getUserCertificates() {
    return this.apiClient.request('/api/users/certificates');
  }

  // User progress
  async updateCourseProgress(courseId, progress) {
    return this.apiClient.request(`/api/courses/${courseId}/progress`, {
      method: 'PUT',
      body: { progress },
    });
  }
}

export default new LearningApiClient();
